var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLogoKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 30,
    fill: "#005add"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.22,26.43H62.71a9.92,9.92,0,0,0-6.27,2.33L32.21,49.1a9.94,9.94,0,0,0-1.22,14l6.39,7.61a9.94,9.94,0,0,0,14,1.22l10-8.37v92.06a9.94,9.94,0,0,0,9.94,9.94h9.94a9.94,9.94,0,0,0,9.94-9.94V36.37A9.94,9.94,0,0,0,81.22,26.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.88,108.29a9.94,9.94,0,1,0,13.57-3.63A9.93,9.93,0,0,0,101.88,108.29Zm11.2,6.47a3,3,0,1,1-1.09-4.1A3,3,0,0,1,113.08,114.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159.5,130.77a9.94,9.94,0,1,0,3.64,13.57A9.94,9.94,0,0,0,159.5,130.77Zm-2.37,10.1a3,3,0,1,1-1.1-4.09A3,3,0,0,1,157.13,140.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.46,155.38l-4.66-2.69a4,4,0,0,1-1.34-5.55l28.61-48.27a4,4,0,0,1,5.49-1.61l4.65,2.68a4,4,0,0,1,1.35,5.56l-28.62,48.27A4,4,0,0,1,118.46,155.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogoKr);
export default __webpack_public_path__ + "static/media/app_logo_kr.642db7570a89b32ebc2e7b0b349e2f48.svg";
export { ForwardRef as ReactComponent };